module.exports = __webpack_public_path__ + "static/media/mother.c6b886ae.jpg";